import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';
import { rotaDeTela } from '@/features/permissoes/guardas';
import { Planos } from '@/features/planos/componentes/Planos';

const busca = z.object({
  busca: z.string().optional().catch(undefined),
  padrao: z.boolean().optional().catch(undefined),
  template: z.boolean().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
  /** Atalho "Novo plano" do Início (spec 015). */
  novo: z.boolean().optional().catch(undefined),
});

/** Planos de treino (spec 009, CA-01). */
export const Route = createFileRoute('/_autenticado/planos/')({
  ...rotaDeTela('planos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { novo, ...filtros } = Route.useSearch();
  const navigate = Route.useNavigate();
  // O atalho do Início abre o formulário e sai da URL (recarregar não abre de novo).
  useEffect(() => {
    if (novo === true) void navigate({ search: filtros, replace: true });
  }, [novo, filtros, navigate]);
  return (
    <Planos
      abrirNovo={novo === true}
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
